import styled from "styled-components";

export const IconTitleTextTooltipTitleBox = styled.div`
    color: ${props => props.theme.colors.brandPrimary};
    ${({theme}) => theme.font.presets.bold};
    font-size: 12px;
 `;